/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Standard_750mlInputs */

const en_val_standard_750ml = /** @type {(inputs: Val_Standard_750mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard (750ml)`)
};

const es_val_standard_750ml = /** @type {(inputs: Val_Standard_750mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estándar (750ml)`)
};

const fr_val_standard_750ml = /** @type {(inputs: Val_Standard_750mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard (750ml)`)
};

const de_val_standard_750ml = /** @type {(inputs: Val_Standard_750mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard (750ml)`)
};

const ja_val_standard_750ml = /** @type {(inputs: Val_Standard_750mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準 (750ml)`)
};

const zh_val_standard_750ml = /** @type {(inputs: Val_Standard_750mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标准瓶 (750ml)`)
};

const ar_val_standard_750ml = /** @type {(inputs: Val_Standard_750mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قياسي (750 مل)`)
};

const id_val_standard_750ml = /** @type {(inputs: Val_Standard_750mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standar (750ml)`)
};

const it_val_standard_750ml = /** @type {(inputs: Val_Standard_750mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard (750ml)`)
};

const ru_val_standard_750ml = /** @type {(inputs: Val_Standard_750mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стандартная (750мл)`)
};

const pt_val_standard_750ml = /** @type {(inputs: Val_Standard_750mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padrão (750ml)`)
};

const ko_val_standard_750ml = /** @type {(inputs: Val_Standard_750mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기본 (750ml)`)
};

/**
* | output |
* | --- |
* | "Standard (750ml)" |
*
* @param {Val_Standard_750mlInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_standard_750ml = /** @type {((inputs?: Val_Standard_750mlInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Standard_750mlInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_standard_750ml(inputs)
	if (locale === "es") return es_val_standard_750ml(inputs)
	if (locale === "fr") return fr_val_standard_750ml(inputs)
	if (locale === "de") return de_val_standard_750ml(inputs)
	if (locale === "ja") return ja_val_standard_750ml(inputs)
	if (locale === "zh") return zh_val_standard_750ml(inputs)
	if (locale === "ar") return ar_val_standard_750ml(inputs)
	if (locale === "id") return id_val_standard_750ml(inputs)
	if (locale === "it") return it_val_standard_750ml(inputs)
	if (locale === "ru") return ru_val_standard_750ml(inputs)
	if (locale === "pt") return pt_val_standard_750ml(inputs)
	return ko_val_standard_750ml(inputs)
});